import { IconBaseProps } from '@vertex-protocol/web-ui';

export function VisaLogoIcon(props: IconBaseProps) {
  return (
    <svg viewBox="0 0 28 10" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_36413_9001)">
        <path
          d="M18.2332 0.0153809C16.2472 0.0153809 14.4723 1.14788 14.4723 3.23979C14.4723 5.63907 17.62 5.80477 17.62 7.01027C17.62 7.51785 17.0914 7.97214 16.1881 7.97214C14.9066 7.97214 13.9487 7.33736 13.9487 7.33736L13.5388 9.44867C13.5388 9.44867 14.6422 9.98489 16.1072 9.98489C18.2786 9.98489 19.9874 8.79695 19.9874 6.66901C19.9874 4.13359 16.8265 3.97282 16.8265 2.85418C16.8265 2.45655 17.2605 2.02105 18.161 2.02105C19.1771 2.02105 20.0059 2.48273 20.0059 2.48273L20.4072 0.443803C20.4072 0.443803 19.505 0.0153809 18.233 0.0153809H18.2332ZM0.062076 0.169379L0.013916 0.477066C0.013916 0.477066 0.849436 0.645232 1.60208 0.980947C2.57116 1.36563 2.64004 1.58985 2.80328 2.28531L4.58156 9.82596H6.96548L10.638 0.169379H8.25964L5.8998 6.73492L4.93688 1.16944C4.84868 0.532505 4.40124 0.169071 3.85384 0.169071H0.062356L0.062076 0.169379ZM11.5944 0.169379L9.7288 9.82596H11.9968L13.8557 0.169379H11.5944ZM24.2437 0.169379C23.6969 0.169379 23.4071 0.491542 23.1946 1.05425L19.8718 9.82596H22.2501L22.7102 8.36391H25.6076L25.8873 9.82596H27.9859L26.1553 0.169379H24.2437ZM24.5531 2.77841L25.2582 6.40198H23.3696L24.5534 2.77841H24.5531Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_36413_9001">
          <rect width="28" height="10" />
        </clipPath>
      </defs>
    </svg>
  );
}
